import { action, makeObservable, observable } from "mobx";
import { v4 } from 'uuid';

export class VariationStore {
    @observable id;
    @observable title = '';
    @observable imageId = null;
    @observable color = null;
    @observable tags = [];
    /** Weighted vocab entries: [{ id, weight }]. */
    @observable styles = [];
    @observable roomTypes = [];
    @observable materials = [];
    /** Weighted vocab shades: [{ shade, weight }]. */
    @observable colors = [];
    @observable accessTier = 'free';
    @observable coinPrice = null;

    constructor(variation) {
        makeObservable(this);
        if (variation) {
            this.id = variation.id;
            this.setTitle(variation.title);
            this.setImageId(variation.imageId);
            this.setColor(variation.color);
            (variation.tags || []).forEach(tag => this.addTag(tag));
            this.styles = variation.styles || [];
            this.roomTypes = variation.roomTypes || [];
            this.materials = variation.materials || [];
            this.colors = variation.colors || [];
            if (variation.accessTier) this.setAccessTier(variation.accessTier);
            if (variation.coinPrice != null) this.setCoinPrice(variation.coinPrice);
        } else {
            this.id = v4();
        }
    }

    @action.bound setTitle = (title) => this.title = title;
    @action.bound setImageId = (imageId) => this.imageId = imageId;
    @action.bound setColor = (color) => this.color = color;
    @action.bound addTag = (tag) => this.tags.push(tag);
    @action.bound removeTag = (tag) => this.tags.splice(this.tags.indexOf(tag), 1);
    @action.bound setAccessTier = (tier) => {
        this.accessTier = tier;
        if (tier !== 'unlockable') this.coinPrice = null;
    };
    @action.bound setCoinPrice = (price) => this.coinPrice = price;
    @action.bound setStyles = (styles) => this.styles = styles;
    @action.bound setRoomTypes = (roomTypes) => this.roomTypes = roomTypes;
    @action.bound setMaterials = (materials) => this.materials = materials;
    @action.bound setColors = (colors) => this.colors = colors;
}
